import Content from "@/components/Content.tsx";
import Header from "@/Header.tsx";
import User_Messages from "@/user/User_Messages.tsx";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";

export const Route = createFileRoute('/_app/profile/messages')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Header />
        <Content>
            <User_Messages />
        </Content>
    </>
}
